import { render } from "./EmployeeDelegateApprovals.vue?vue&type=template&id=5338f20a"
import script from "./EmployeeDelegateApprovals.vue?vue&type=script&lang=js"
export * from "./EmployeeDelegateApprovals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__